module.exports = __webpack_public_path__ + "img/skillscommon.fb1f320e.png";